// extracted by mini-css-extract-plugin
export var stepActive = "_1a-3";
export var stepCompleted = "_1a-4";
export var stepConnectorLine = "_1a-b";
export var stepIndicatorCircle = "_1a-6";
export var stepIndicatorCircleCompleted = "_1a-7";
export var stepIndicatorCircleDefault = "_1a-8";
export var stepIndicatorTextCompleted = "_1a-9";
export var stepIndicatorTextDefault = "_1a-a";
export var stepPending = "_1a-5";
export var wizardContainer = "_1a-1";
export var wizardContent = "_1a-2";
export var wizardModal = "_1a-0";